const ml = {
  // Header
  address: "വിലാസം",
  home: "ഹോം",
  about: "ഞങ്ങളെ കുറിച്ച്",
  schemes: "പദ്ധതികൾ",
  howItWorks: "എങ്ങനെ പ്രവർത്തിക്കുന്നു",
  login: "ലോഗിൻ",

  // Banner
  bannerTitle: "റിസ്ക് & വെൽഫെയർ ഫണ്ട് മാനേജ്‌മെന്റ് സിസ്റ്റം",
  bannerTagline: "ആശ്രിതർക്ക് ആശ്വാസം , സംഘങ്ങൾക്ക് പരിരക്ഷ",
  bannerSubtitle: "റിസ്‌ക് & വെൽഫെയർ പദ്ധതികൾ ഏകീകൃതമായി കൈകാര്യം ചെയ്യാനുള്ള ഒരു ഡിജിറ്റൽ പ്ലാറ്റ്‌ഫോം.",
  readMore: "കൂടുതൽ വായിക്കുക",

  // About service cards
  riskFundBeneficiaries: "റിസ്ക് ഫണ്ട് ഗുണഭോക്താക്കൾ",
  riskFundBeneficiariesDesc:
    "മരണം, അപകടം അല്ലെങ്കിൽ വൈകല്യ ക്ലെയിമുകൾക്ക് അപേക്ഷിക്കുകയും സ്ഥിതി ട്രാക്ക് ചെയ്യുകയും ചെയ്യുക",
  applyForClaim: "ക്ലെയിമിന് അപേക്ഷിക്കുക",
  societiesAndBanks: "സൊസൈറ്റികളും ബാങ്കുകളും",
  societiesAndBanksDesc:
    "അംഗങ്ങളുടെ സംഭാവനകളും ക്ഷേമ പ്രവർത്തനങ്ങളും കൈകാര്യം ചെയ്യുന്ന രജിസ്റ്റർ ചെയ്ത സ്ഥാപനങ്ങൾ",
  registerSociety: "സൊസൈറ്റി രജിസ്റ്റർ ചെയ്യുക",

  // About section
  aboutUsLabel: "ഞങ്ങളെ കുറിച്ച്",
  aboutRWFMS: "ആർ.ഡബ്ല്യു.എഫ്.എം.എസ് നെ കുറിച്ച്",
  aboutDesc:
    "റിസ്ക് & വെൽഫെയർ ഫണ്ട് മാനേജ്‌മെന്റ് സിസ്റ്റം (RWFMS) ഗുണഭോക്താക്കൾക്കും സഹകരണ സ്ഥാപനങ്ങൾക്കും റിസ്ക് & വെൽഫെയർ പദ്ധതികൾ കാര്യക്ഷമമായി ഉപയോഗിക്കാനും നിയന്ത്രിക്കാനും സഹായിക്കുന്നു.",
  digitalProcessing: "ഡിജിറ്റൽ പ്രോസസ്സിങ്",
  digitalProcessingDesc:
    "അപേക്ഷയുടെ തുടക്കം മുതൽ അവസാനം വരെ മുഴുവൻ നടപടികളും ഓൺലൈനായി നടത്തി രേഖാപ്രക്രിയകൾ ഒഴിവാക്കുന്നു.",
  transparentGovernance: "സുതാര്യമായ സംവിധാനം",
  transparentGovernanceDesc:
    "ഓരോ ഇടപാടിനും തത്സമയ സ്റ്റാറ്റസ് ട്രാക്കിംഗും സമഗ്രമായ പൊതുജന പരിശോധനാ സൗകര്യവും ഉറപ്പാക്കുന്നു.",
  swiftDisbursement: "വേഗത്തിലുള്ള വിതരണം",
  swiftDisbursementDesc:
    "അർഹമായ സഹായ തുക വൈകാതെ, യാതൊരു തടസ്സവും ഇല്ലാതെ, സുരക്ഷിതമായി ബന്ധപ്പെട്ട സൊസൈറ്റിയുടെ ബാങ്ക് അക്കൗണ്ടിലേക്ക് സമയബന്ധിതമായി കൈമാറുന്നു.",

  // Schemes section
  schemesCovered: "ഉൾപ്പെടുന്ന പദ്ധതികൾ",
  riskFundSchemes: "റിസ്ക് ഫണ്ട് പദ്ധതികൾ",
  riskFundSchemesDesc:
"റിസ്‌ക് & വെൽഫെയർ ഫണ്ട് മാനേജ്മെന്റ് സംവിധാനം, കൈമാറ്റ രീതിയിൽ നടന്നിരുന്ന നടപടികളെ സുരക്ഷിതവും പൂർണ്ണമായും ഡിജിറ്റൽ രീതിയിലേക്കാണ് മാറ്റുന്നത്. ഇത് കേരള കോ-ഓപ്പറേറ്റീവ് ഡെവലപ്മെന്റ് ആൻഡ് വെൽഫെയർ ഫണ്ട് ബോർഡിന്നുവേണ്ടി ഒരുക്കിയ പ്ലാറ്റ്‌ഫോമാണ്. ഗുണഭോക്താക്കൾക്ക് അവരുടെ അർഹമായ സഹായം വൈകാതെ, പരമാവധി സുതാര്യതയോടെ ലഭ്യമാക്കുന്നതാണ് ഈ സംവിധാനത്തിന്റെ ലക്ഷ്യം.റിസ്‌ക് ഫണ്ട് പദ്ധതിയിലെ അംഗത്വം, പ്രീമിയം പേയ്മെന്റുകൾ എന്നിവ സൊസൈറ്റികൾ ഈ പ്ലാറ്റ്‌ഫോമിലൂടെ കൈകാര്യം ചെയ്യുന്നു. പൊതുജന ഗുണഭോക്താക്കൾക്ക് ഇവിടെ നിന്ന് ക്ലെയിം അപേക്ഷിക്കാനും സ്റ്റാറ്റസ് പരിശോധിക്കാനും കഴിയും.",
  deathClaimSupport: "മരണ അപേക്ഷ സഹായം",
  deathClaimDesc:
    "റിസ്ക് & വെൽഫെയർ ഫണ്ട് മാനേജ്‌മെന്റ് സിസ്റ്റം കേരള സഹകരണ വികസന & വെൽഫെയർ ഫണ്ട് ബോർഡിന് ആയി മാനുവൽ പ്രക്രിയകൾ സുരക്ഷിതവും പേപ്പർരഹിതവുമായ ഡിജിറ്റൽ അന്തരീക്ഷത്തിലേക്ക് മാറ്റുന്നു. ഗുണഭോക്താക്കൾക്ക് അർഹമായ പിന്തുണ കാലതാമസമില്ലാതെ ലഭിക്കുന്നു എന്ന് ഉറപ്പാക്കുക ആണ് ഞങ്ങളുടെ ലക്ഷ്യം.",
  treatmentClaimSupport: "ചികിത്സ അപേക്ഷ സഹായം",
  treatmentClaimDesc:
    "ഗുരുതരമായ, ജീവൻ അപകടകരമായ അസുഖം ബാധിച്ച അംഗങ്ങൾക്ക് സാമ്പത്തിക സഹായം.",

  // Welfare section
  welfareFundSchemes: "വെൽഫെയർ ഫണ്ട് പദ്ധതികൾ",
  welfareFundSchemesDesc:
    "വെൽഫെയർ ഫണ്ട് പദ്ധതി, സാമ്പത്തികമായി ദുർബലരായ സഹകരണ സൊസൈറ്റികളെ പുനരുജ്ജീവിപ്പിക്കുകയും ശക്തിപ്പെടുത്തുകയും ചെയ്യുന്നതിനായി രൂപകൽപ്പന ചെയ്തിട്ടുള്ളതാണ്. സാമ്പത്തിക നഷ്ടം ഉണ്ടാകുന്ന സന്ദർഭത്തിൽ വായ്പ സഹായം ലഭിക്കുന്നതിനും കേരള കോ-ഓപ്പറേറ്റീവ് ഡെവലപ്മെന്റ് ആൻഡ് വെൽഫെയർ ഫണ്ട് ബോർഡ് (KCDWFB) നൽകുന്ന സേവനങ്ങൾ പ്രയോജനപ്പെടുത്തുന്നതിനും സൊസൈറ്റികൾ ഈ പദ്ധതിയിൽ ചേർന്ന് അംഗത്വം നേടേണ്ടതാണ്. ഈ പോർട്ടലിലൂടെ, സൊസൈറ്റികൾക്ക് പുതിയ അംഗത്വം എടുക്കാനും, നിലവിലുള്ള അംഗത്വം സജീവമാക്കാനും, വാർഷിക സംഭാവനകൾ അടയ്ക്കാനും, പുതുക്കൽ പേയ്മെന്റുകൾ നടത്താനും സാധിക്കും. ഇത് ആവശ്യമുള്ള ഏത് സന്ദർഭത്തിലും ബോർഡിൽ നിന്ന് സാമ്പത്തിക സഹായം ലഭിക്കുന്നതിനുള്ള തുടർ അർഹത ഉറപ്പാക്കുന്നു.",
  societyEnrollment: "സൊസൈറ്റി എൻറോൾമെന്റ്",
  societyEnrollmentDesc:
    "കേരള കോ-ഓപ്പറേറ്റീവ് ഡെവലപ്മെന്റ് ആൻഡ് വെൽഫെയർ ഫണ്ട് ബോർഡിന്റെ ക്ഷേമ പദ്ധതികളിൽ സൊസൈറ്റികൾ ചേരുന്നതിനുള്ള ലളിതമായ പ്രക്രിയ.",
  annualRenewal: "വാർഷിക പുതുക്കൽ",
  annualRenewalDesc:
    "വാർഷിക അംഗത്വ പരിപാലനത്തിനായി ഓട്ടോമേറ്റഡ് ഓർമ്മപ്പെടുത്തലുകളും ലളിതമായ പേയ്‌മെന്റ് ഗേറ്റ്‌വേകളും.",

  // How it Works
  howItWorksLabel: "എങ്ങനെ പ്രവർത്തിക്കുന്നു",
  easySteps: "ജോലി പ്രക്രിയയുടെ ലളിതമായ 4 ഘട്ടങ്ങൾ",
  register: "രജിസ്റ്റർ",
  registerDesc: "ഗുണഭോക്താവ് അല്ലെങ്കിൽ സൊസൈറ്റി ആയി സൈൻ അപ്പ് ചെയ്യുക.",
  submitClaim: "അപേക്ഷ സമർപ്പിക്കുക",
  submitClaimDesc: "ആവശ്യമായ രേഖകൾ ഓൺലൈനായി അപ്‌ലോഡ് ചെയ്യുക.",
  verification: "പരിശോധന",
  verificationDesc: "സൊസൈറ്റി, വകുപ്പ് & ബോർഡ് തലത്തിൽ സ്ഥിരീകരണം.",
  disbursement: "തുക ലഭിക്കൽ",
  disbursementDesc: "അംഗീകരിച്ച തുക നേരിട്ട് സൊസൈറ്റി ബാങ്ക് അക്കൗണ്ടിലേക്ക് ലഭിക്കും.",
};

export default ml;
